module.exports = new __parcel__URL__("meddle.af40fbcb.jpg").toString();